module.exports = __webpack_public_path__ + "static/media/Arrow1_mobile.43f7da23.svg";